import { getGranits } from 'src/services/granits';

import useLoadDataList from './useLoadDataList';

export const useTexture = () => {
  const { data: granits } = useLoadDataList(getGranits);

  return { granits };
};
